import React from 'react';
import Udesk from 'Udesk';
import { Redirect } from 'react-router-dom';
import LayoutMenu from 'Component/common/layout-menu';
import { CallSentenceClusterResultsWarnContext } from 'src/pages/home';

class trainingCenter extends React.Component {
    isRedirect(currentPath, toPath) {
        if (currentPath === toPath) {
            return true;
        }
        return false;
    }

    render() {
        let { route, location, sdkOptions } = this.props;

        let { locales } = this;
        return (
            <CallSentenceClusterResultsWarnContext.Consumer>
                {({ showSentenceClusterResultsWarn }) => {
                    let navLists = [];
                    // 根据当前用户权限，组装菜单列表
                    //&& Udesk.data.init.user.hasFeature("smart:tag:root")

                    if (Udesk.data.init.user && Udesk.data.init.user.hasFeature('training:fast:root')) {
                        navLists.push({
                            text: locales.components.pages.trainingCenter.fastTraining.title,
                            pathName: 'salesFastTrainingIndex',
                            isActive: (match, location) => {
                                return location.pathname.includes('/fast-training');
                            },
                        });
                    }
                    if (Udesk.data.init.user && Udesk.data.init.user.hasFeature('training:history:root')) {
                        navLists.push({
                            text: locales.components.pages.trainingCenter.trainingHistory.title,
                            pathName: 'salesTrainingHistoryIndex',
                            isActive: (match, location) => {
                                return location.pathname.includes('/training-history');
                            },
                        });
                    }
                    
                    // if (Udesk.data.init.user && Udesk.data.init.user.hasFeature('training:clusterMark:root')) {
                    //     navLists.push({
                    //         text: locales.components.pages.trainingCenter.clusteringAnnotation.title,
                    //         pathName: 'algorithmClusteringAnnotationIndex',
                    //         isActive: (match, location) => {
                    //             return location.pathname.includes('/clustering-annotation-index');
                    //         },
                    //         dot: showSentenceClusterResultsWarn,
                    //     });
                    // }
                    if (Udesk.data.init.user && Udesk.data.init.user.hasFeature('training:subjectMark:root')) {
                        navLists.push({
                            text: /* 话题标注 */ locales.pages.trainingCenter.topicAnnotation,
                            pathName: 'topicCallout',
                            isActive: (match, location) => {
                                return location.pathname.includes('/topic-callout');
                            },
                        });
                    }
                    if (Udesk.data.init.user && Udesk.data.init.user.hasFeature('training:subjectList:root')) {
                        navLists.push({
                            text: /* 话题列表 */ locales.pages.trainingCenter.topicList,
                            pathName: 'topicList',
                            isActive: (match, location) => {
                                return location.pathname.includes('/topic-index');
                            },
                        });
                    }

                    if (Udesk.data.init.user && Udesk.data.init.user.hasFeature("semantic:WordsMining:root")) {
                        navLists.push({
                            text: /* 话术挖掘 */locales.pages.semanticIntelligence.speechMining,
                            pathName: "salesWordsMining",
                            isActive: (match, location) => {
                                return location.pathname.includes("/words-mining");
                            }
                        });
                    }
                    if (Udesk.data.init.user && Udesk.data.init.user.hasFeature("semantic:cluster:root")) {
                        navLists.push({
                            text: /* 聚类分析 */locales.pages.semanticIntelligence.clusterAnalysis,
                            pathName: 'clusteringAnalysis',
                            isActive: (match, location) => {
                                return location.pathname.includes("/clustering-analysis");
                            }
                        });
                    }
                    
                    if (sdkOptions.props.landingPath != null && this.isRedirect(route.path, location.pathname)) {
                        let toPath = location.pathname + sdkOptions.props.landingPath;
                        return <Redirect to={toPath} sdkOptions={sdkOptions} />;
                    } else if (navLists.length > 0 && this.isRedirect(route.path, location.pathname)) {
                        let toPath = null;
                        if (navLists[0].pathName) {
                            toPath = Udesk.ui.routing.getRouteFirstBottomedChildRoutePath({
                                routeName: navLists[0].pathName,
                            });
                        } else {
                            toPath = Udesk.ui.routing.getRouteFirstBottomedChildRoutePath({
                                routeName: navLists[0].children[0].pathName,
                            });
                        }

                        return <Redirect to={toPath} sdkOptions={sdkOptions} />;
                    } else {
                        return (
                            <div className='semantic-intelligence'>
                                <LayoutMenu
                                    {...this.props}
                                    navLists={navLists}
                                    menuTitle={locales.components.pages.menuTitleList.trainingCenterTitle}
                                />
                            </div>
                        );
                    }
                }}
            </CallSentenceClusterResultsWarnContext.Consumer>
        );
    }
}

export default Udesk.react.udeskify(trainingCenter);
